import React from 'react';
import { Poppins } from 'src/common/Poppins';

// Reusable "x/max" character counter, shown top-right of an input. Shared by the AI wizard's risk
// description and the review-form notes so the counters read identically.
export const CharCounter: React.FC<{ value: string; max: number }> = ({ value, max }) => (
  <Poppins px={14} weight={500} color="cflowerBlue" css="text-transform: uppercase; white-space: nowrap;">
    {value.length}/{max}
  </Poppins>
);
